/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector, AppDispatch } from '../store';
import { useDispatch } from 'react-redux';
import { fetchProjectById } from '../store/feature/projectSlice';
import BASE_URL from '../constants/Config';
import { saveComment } from '../store/feature/commentSlice';
import Swal from 'sweetalert2'; // SweetAlert2'yi import ediyoruz

// Slugify fonksiyonu
const slugify = (text: string) => {
  return text
    .toLowerCase()
    .replace(/ /g, '-') // Boşlukları tire ile değiştir
    .replace(/[^\w-]+/g, ''); // Alfanümerik olmayan karakterleri kaldır
};

const ProjectDetail: React.FC = () => {
  const { title } = useParams<{ title: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const { projects, loading } = useAppSelector((state) => state.project);
  const [newComment, setNewComment] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!projects.length && title) {
      const projectId = title.split('-').pop();
      if (projectId) {
        dispatch(fetchProjectById(Number(projectId)));
      }
    }
  }, [dispatch, projects, title]);

  const project = projects.find((p) => slugify(p.title) === title);



   

  const getPhotoUrl = (filePath: string) => {
    const fileName = filePath.split('/').pop();
    return `${BASE_URL}/api/Project/photo/${fileName}`;
  };

  if (loading) {
    return <div className="text-center mt-20">Yükleniyor...</div>;
  }

  if (!project) {
    return <div className="text-center mt-20">Proje bulunamadı.</div>;
  }

  return (
    <div className="pt-20">
      <section className="bg-gray-900 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-6">{project.title}</h1>
        </div>
      </section>
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-lg p-6">
            <img
              src={getPhotoUrl(project.photoUrl)}
              alt={project.title}
              className="w-full h-96 object-contain mb-6"
            />
            <div>
              <h2 className="text-center text-3xl font-bold mb-4">{project.title}</h2>
              <p className="text-gray-700 mb-6 mt-11 whitespace-pre-line leading-relaxed">{project.content}</p>
              
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectDetail;
